/**
 * Product redesign interaction: quantity stepper + Shiprocket Buy Now.
 * Loaded only on the product.redesign template.
 */
(() => {
  // 1. Smooth scroll to reviews widget when clicking trust badge
  const pill = document.querySelector('.redesign-trust-pill');
  if (pill) {
    pill.addEventListener('click', (e) => {
      const target =
        document.querySelector('#judgeme_product_reviews') ||
        document.querySelector('.jdgm-review-widget') ||
        document.querySelector('#shopify-section-1792584911afc698ea') ||
        document.querySelector('[id*="review"]');
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  }

  const purchase = document.querySelector('.redesign-purchase');
  if (!purchase) return;

  const qty = purchase.querySelector('.redesign-qty__input');

  purchase.addEventListener('click', (e) => {
    // 1. Quantity stepper
    const step = e.target.closest('[data-qty]');
    if (step && qty) {
      qty.value = Math.max(1, (parseInt(qty.value, 10) || 1) + Number(step.dataset.qty));
      qty.dispatchEvent(new Event('change', { bubbles: true }));
      return;
    }

    // 2. Buy Now button -> Directly triggers Shiprocket 1-click checkout
    if (e.target.closest('[data-buy-now]')) {
      e.preventDefault();

      const checkout =
        document.querySelector('.sr-headless-checkout') ||
        document.querySelector('main .sr-headless-checkout') ||
        document.querySelector('.shopify-payment-button__button') ||
        document.querySelector('main [name="checkout"]');

      if (checkout) {
        checkout.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true }));
      } else {
        const form = purchase.closest('form') || document.querySelector('product-form form');
        const variantId = form?.querySelector('.product-variant-id')?.value || form?.querySelector('[name="id"]')?.value;
        const count = qty?.value || 1;
        if (variantId) {
          window.location.href = `${window.Shopify?.routes?.root || '/'}cart/${variantId}:${count}?checkout=1`;
        }
      }
    }
  });
})();

/* Before/after slider: one delegated listener, works on first paint and after
   any section re-render — the range input does all the interaction. */
document.addEventListener('input', (e) => {
  const range = e.target.closest?.('[data-ba-range]');
  if (range) range.closest('.redesign-ba-card').style.setProperty('--slider-pos', `${range.value}%`);
});